import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { apiRequest } from "../utils/api";
import FormFeedback, { FieldError, inputErrorClass } from "./Common/FormFeedback";
import "./LoginRegister.css";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);
  const token = searchParams.get("token") || "";

  function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setSuccess(false);
    setError(false);
    setFieldErrors({});
    setValidationErrors([]);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("token", token);
    formData.append("password", password);
    formData.append("password_confirmation", passwordConfirmation);

    apiRequest("/reset-password", {
      method: "POST",
      body: formData,
    })
      .then((data) => {
        setIsLoading(false);
        setPassword("");
        setPasswordConfirmation("");
        setSuccess(data.message || "Password reset successfully.");
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.data?.status === "validation_error") {
          setValidationErrors(error.messages);
          setFieldErrors(error.errors);
        } else {
          setError(error.message);
        }
      });
  }

  return (
    <section className="login-section auth-page">
      <div className="outer-box">
        <div className="login-form default-form auth-login-form">
          <div className="form-inner">
            <h3>Reset Password</h3>
            <FormFeedback success={success} error={error || (!token && "Password reset token is missing.")} validationErrors={validationErrors} />

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  className={inputErrorClass(fieldErrors, "email")}
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <FieldError errors={fieldErrors} name="email" />
              </div>

              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  className={inputErrorClass(fieldErrors, "password")}
                  placeholder="New password"
                  required
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <FieldError errors={fieldErrors} name="password" />
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm password"
                  required
                  value={passwordConfirmation}
                  onChange={(event) => setPasswordConfirmation(event.target.value)}
                />
              </div>

              <div className="form-group">
                <button className="theme-btn btn-style-one" type="submit" disabled={isLoading || !token}>
                  {isLoading ? "Saving..." : "Reset Password"}
                </button>
              </div>
            </form>

            <div className="bottom-box">
              <div className="text">
                <Link className="call-modal signup" to="/login">Back to Login</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
